import styled from '@emotion/styled';

import colors from '$variables/colors';
import { spacing } from '$variables/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: ${spacing.small} ${spacing.medium} ${spacing.small} 0;

  line-height: 20px;
`;

// 170px = 234px (total) - 40px (avatar) - 8px (avatar margin) - 16px (padding right)
const TextContent = styled.div`
  width: 170px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const Name = styled(TextContent)`
  color: ${colors.shadow6};
`;

export const Email = styled(TextContent)`
  color: ${colors.shadow5};
  font-size: 12px;
`;

export const Info = styled.div`
  margin-left: ${spacing.xSmall};
`;

export const Separator = styled.div`
  height: 1px;
  background-color: ${colors.border1};
  width: 888px;
  position: absolute;
`;
